import { z } from 'zod';
import type { ApiContract } from '../contracts';

/**
 * Public waitlist request body. A prospect on the marketing site with no account
 * submits their email on the app's `/request-access` page. `source` records the
 * acquisition channel (e.g. 'website'); it's optional and additive.
 */
export const WaitlistSignupRequestSchema = z.object({
  email: z.string().trim().email(),
  source: z.string().trim().max(100).optional(),
});
export type WaitlistSignupRequest = z.infer<typeof WaitlistSignupRequestSchema>;

/**
 * Deliberately opaque: `{ ok: true }` regardless of whether the email was new or
 * already on the list, so the endpoint never reveals list membership. New fields
 * can be added later without breaking clients.
 */
export const WaitlistSignupResponseSchema = z.object({
  ok: z.literal(true),
});
export type WaitlistSignupResponse = z.infer<typeof WaitlistSignupResponseSchema>;

/** Public, unauthenticated: a prospect has no account. */
export const waitlistSignupContract = {
  method: 'POST',
  path: '/api/waitlist',
  body: WaitlistSignupRequestSchema,
  response: WaitlistSignupResponseSchema,
} as const satisfies ApiContract;
